<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>{{ $t('Add.Column.Column') }} Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
    <div class="class-names">
      <span v-for="(name, index) in classNames" :key="index" class="class-pill">
        {{ name }}
        <span class="material-symbols-outlined class-remove" @click="removeClassName(index)">close</span>
      </span>
    </div>  
    </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('style')" class="accordion-content">
   <div class="divider columnWidthDivider">
      <div class="columnWidth">
      <label class="contentLabel" for="wColumn1">{{ $t('Add.Column.Column') }} 1</label>
      <input type="text" id="wColumn1" v-model="firstColumnWidth" placeholder="auto"/>
      </div>
      <div class="columnWidth">
      <label class="contentLabel" for="wColumn2">{{ $t('Add.Column.Column') }} 2</label>
      <input type="text" id="wColumn2" v-model="secondColumnWidth" placeholder="auto" />
      </div>
      <div v-if="columnsCount == 3" class="columnWidth columnWidthThird">
      <label class="contentLabel" for="wColumn3">{{ $t('Add.Column.Column') }} 3</label>
      <input type="text" id="wColumn3" v-model="thirdColumnWidth" placeholder="auto" />
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="columnsGap">{{ $t('Add.Column.ColumnsGap') }}</label>
      <div class="range-container">
        <input type="range" min="0" max="100" v-model="columnsGap" class="slider" id="columnsGap" />
        <span>{{ columnsGap }} px</span>
      </div>
    </div>
    <BackgroundColorProp :sharedData="sharedData" />
    <div class="divider"> 
      <p>{{ $t('Add.Column.VerticalAlignment') }}</p>
      <label class="contentLabel" for="vaColumn1">{{ $t('Add.Column.Column') }} 1</label>
      <select v-model=firstVerticalAlign id="vaColumn1">
          <option value="middle">middle</option>
          <option value="top">top</option>
          <option value="bottom">bottom</option>
      </select>
      <label class="contentLabel" for="vaColumn2">{{ $t('Add.Column.Column') }} 2</label>
      <select v-model=secondVerticalAlign id="vaColumn2">
          <option value="middle">middle</option>
          <option value="top">top</option>
          <option value="bottom">bottom</option>
      </select>
      <label v-if="columnsCount == 3"  class="contentLabel" for="vaColumn3">{{ $t('Add.Column.Column') }} 3</label>
      <select v-if="columnsCount == 3"  v-model=thirdVerticalAlign id="vaColumn3">
          <option value="middle">middle</option>
          <option value="top">top</option>
          <option value="bottom">bottom</option>
      </select>
    </div>
    <div class="divider">
      <p>{{ $t('Add.Column.ColumnsCount') }}</p>
      <div class="input-container">
        <label>
          <input type="radio" class="radios" name="columnsCount" value="2" v-model="columnsCount" />
          <span class="radioSelect firstSelect">2</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="columnsCount" value="3" v-model="columnsCount" />
          <span class="radioSelect lastSelect">3</span>
        </label>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
     <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('positioning')" class="accordion-content">
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
export default {
  name: 'AddColumnsContainer',
  components: {
    NameProp,
    ClassNamesProp,
    PaddingProp,
    BackgroundColorProp,
    CopyBlock,
  },
  props: ['sharedData'],
  data(){
    return {//activeSections: ['main'], 
    newClassName: '',
    } // Default aktivierter Reiter}
  },
  computed: {
    columnsGap: {
      get() {
        return this.sharedData?.data?.props?.columnsGap || 0;
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.columnsGap = value;
      },
    },
    firstColumnWidth: {
      get() {
        if(this.sharedData?.data?.props?.fixedWidths){
        return this.sharedData?.data?.props?.fixedWidths[0] || '';
      } else {
        console.log(this.sharedData?.data?.props?.fixedWidths)
        return ''
        
      }
      },
      set(value) {
        let widthValue = value;
        if(value === '' || !/^\d+$/.test(value) || value > 600) widthValue = null; //add Check for max width 
        /* if (!this.sharedData.data.props) this.sharedData.data.props = {}; */
        if (!this.sharedData.data.props.fixedWidths) {
          this.sharedData.data.props.fixedWidths = [widthValue, null, null];
        }else{
          if(this.secondColumnWidth + this.thirdColumnWidth + widthValue > 600){
            this.sharedData.data.props.fixedWidths[0] = null;
          }else{
          this.sharedData.data.props.fixedWidths[0] = widthValue;
          }
        }
      },
    },
    secondColumnWidth: {
      get() {
        if(this.sharedData?.data?.props?.fixedWidths){
        return this.sharedData?.data?.props?.fixedWidths[1] || '';
        }else {
          return '' 
      }
      },
      set(value) {
        let widthValue = value;
        if(value === '' || !/^\d+$/.test(value) || value > 600) widthValue = null;//add Check for max width 
        /* if (!this.sharedData.data.props) this.sharedData.data.props = {}; */
        if (!this.sharedData.data.props.fixedWidths){
         this.sharedData.data.props.fixedWidths = [null, widthValue, null];
        }else {
          if(this.firstColumnWidth + this.thirdColumnWidth + widthValue > 600){
            this.sharedData.data.props.fixedWidths[1] = null;
          }else{
          this.sharedData.data.props.fixedWidths[1] = widthValue;
          }
        }
      },
    },
    thirdColumnWidth: {
      get() {
        if(this.sharedData?.data?.props?.fixedWidths){
        return this.sharedData?.data?.props?.fixedWidths[2] || '';
      } else {
        return ''
      }
      },
      set(value) {
        let widthValue = value;
        if(value === '' || !/^\d+$/.test(value) || value > 600) widthValue = null; //add Check for max width 
        /* if (!this.sharedData.data.props) this.sharedData.data.props = {}; */
        if (!this.sharedData.data.props.fixedWidths){
        this.sharedData.data.props.fixedWidths = [null, null, widthValue];
        }else{
          if(this.firstColumnWidth + this.secondColumnWidth + widthValue > 600){
            this.sharedData.data.props.fixedWidths[2] = null;
          }else{
          this.sharedData.data.props.fixedWidths[2] = widthValue;
          }
        }
      },
    },
    firstVerticalAlign: {
      get() {
        if(this.sharedData?.data?.props?.verticalAlign){
        return this.sharedData?.data?.props?.verticalAlign[0] || '';
      } else {
        return ''
      }
      },
      set(value) {
        if (!this.sharedData.data.props.verticalAlign){
        this.sharedData.data.props.verticalAlign = [value, null, null];
        }else{
          this.sharedData.data.props.verticalAlign[0] = value;
        }
      },
    },
    secondVerticalAlign: {
      get() {
        if(this.sharedData?.data?.props?.verticalAlign){
        return this.sharedData?.data?.props?.verticalAlign[1] || '';
      } else {
        return ''
      }
      },
      set(value) {
        if (!this.sharedData.data.props.verticalAlign){
        this.sharedData.data.props.verticalAlign = [null, value, null];
        }else{
          this.sharedData.data.props.verticalAlign[1] = value;
        }
      },
    },
    thirdVerticalAlign: {
      get() {
        if(this.sharedData?.data?.props?.verticalALign){
        return this.sharedData?.data?.props?.verticalAlign[2] || '';
      } else {
        return ''
      }
      },
      set(value) {
        if (!this.sharedData.data.props.verticalAlign){
        this.sharedData.data.props.verticalAlign = [null, null, value];
        }else{
          this.sharedData.data.props.verticalAlign[2] = value;
        }
      },
    },
    columnsCount: {
      get() {
        return this.sharedData?.data?.props?.columnsCount || 1;
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.columnsCount = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
}};
</script>

<style scoped>
@import '../../styles/addComponents.css';



.columnWidthDivider{
  display: flex;
  justify-content: start;
} 

.columnWidth{
  width: 30%;
  margin-right: 15px;
}

.columnWidthThird {
  margin-right: auto;
}


</style>
